import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1AdminPrivilegeIDOCToArray} from "../../../../util/Payload";
import MemoryContext from "../../../../util/MemoryContext";
import {v4 as uuidv4} from "uuid";
import EnlilAxios from "../../../../util/EnlilAxios";

class AdminPrivilegeConstraintEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, _) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.AdminPrivilegeConstraint-001";

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/admin_privilege_constraints",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                "Name": this.getAttributeValue("Name"),
                "ParentUSID": this.getAttributeValue("ParentUSID"),
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1AdminPrivilegeIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        let adminPrivilege = {
            "USID": MemoryContext.components["AdminPrivilege-AdminPrivilegeUSID"]
        }

        let adminPrivilegeConstraint = {}
        adminPrivilegeConstraint["USID"] = uuidv4();
        adminPrivilegeConstraint["AdminPrivilegeUSID"] = MemoryContext.components["AdminPrivilege-AdminPrivilegeUSID"];
        adminPrivilegeConstraint["ParentUSID"] = MemoryContext.components["AdminPrivilege-ParentUSID"];
        adminPrivilegeConstraint["Name"] = this.getAttributeValue("Name");
        adminPrivilegeConstraint["Type"] = MemoryContext.components["AdminPrivilege-Type"];
        adminPrivilegeConstraint["EmployeeUSID"] = this.getAttributeValue("EmployeeUSID");

        adminPrivilege["AdminPrivilegeConstraint"] = adminPrivilegeConstraint

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminPrivilege-001";
        payload.ShifamedMessage["AdminPrivilege"] = adminPrivilege;

        return payload;
    };

    performInsert = () => {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/admin_privileges",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminPrivilege-001",
                "idoc-response": this.getIDOCResponse(),
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1AdminPrivilegeIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {
            "ShifamedMessage": {
                "-idoc": "v1.AdminPrivilegeConstraint-001",
                "AdminPrivilegeConstraint": {
                    "USID": MemoryContext.components["AdminPrivilege-AdminPrivilegeConstraintUSID"]
                }
            }
        }

        let options = {
            method: "DELETE",
            url: "t3/v1/admin_privilege_constraints",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminPrivilegeConstraint-001"
            },
        };
        this.notifyDeleteStartListeners();
        EnlilAxiosRestAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}



export default AdminPrivilegeConstraintEnterpriseComponent;